module.exports = __webpack_public_path__ + "static/firewatch-board-78b5072991922db911ba22670c306357.webp";